import { googleMapsDefaults } from '@/constants';
import { Ref } from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export const createGeoPoint = (latitude: number, longitude: number) => {
  return new firebase.firestore.GeoPoint(latitude, longitude);
};

export const cloneGeoPoint = (geoPoint: firebase.firestore.GeoPoint) => {
  return new firebase.firestore.GeoPoint(geoPoint.latitude, geoPoint.longitude);
};

export const truncateLatLng = (latLng: google.maps.LatLng) =>
  new google.maps.LatLng({
    lat: Number(latLng.lat().toFixed(googleMapsDefaults.latLngPrecision)),
    lng: Number(latLng.lng().toFixed(googleMapsDefaults.latLngPrecision))
  });

export const latLngToLatLngLiteral = (latLng: google.maps.LatLng): google.maps.LatLngLiteral => ({
  lat: latLng.lat(),
  lng: latLng.lng()
});

export const latLngLiteralToLatLng = (latLngLiteral: google.maps.LatLngLiteral): google.maps.LatLng =>
  new google.maps.LatLng({
    lat: latLngLiteral.lat,
    lng: latLngLiteral.lng
  });

export const geoPointToLatLng = (geoPoint: firebase.firestore.GeoPoint): google.maps.LatLng =>
  new google.maps.LatLng({
    lat: geoPoint.latitude,
    lng: geoPoint.longitude
  });

export const latLngToGeoPoint = (latLng: google.maps.LatLng): firebase.firestore.GeoPoint =>
  createGeoPoint(latLng.lat(), latLng.lng());

export const geoPointToLatLngLiteral = (geoPoint: firebase.firestore.GeoPoint): google.maps.LatLngLiteral => ({
  lat: geoPoint.latitude,
  lng: geoPoint.longitude
});

export const latLngLiteralToGeoPoint = (latLngLiteral: google.maps.LatLngLiteral) =>
  createGeoPoint(latLngLiteral.lat, latLngLiteral.lng);

export const geolocationCoordsToLatLng = (
  coords: Ref<{
    latitude: number;
    longitude: number;
  } | null>
): google.maps.LatLng =>
  new google.maps.LatLng({
    lat: coords.value?.latitude || 0,
    lng: coords.value?.longitude || 0
  });
